import A_CircleButton from '@/components/A_Atoms/A_CircleButton/A_CircleButton';
import styles from './O_HeaderMobile.module.css';
import { Q_Icon } from '@/components/Q_Quarks/Q_Icon/Q_Icon';
import { Link } from 'react-router-dom';
import { PATHS } from '@/constants/paths';
import A_Logo from '@/components/A_Atoms/A_Logo/A_Logo';
import A_SearchInput from '@/components/A_Atoms/A_SearchInput/A_SearchInput';
import { getTranslation } from '@/constants/translations';
import { useLanguage } from '@/contexts/LanguageContext';
import Q_BlurEffect from '@/components/Q_Quarks/Q_BlurEffect/Q_BlurEffect';
import { ReactNode, useState } from 'react';
import O_HeaderBurgerMenu from './O_HeaderBurgerMenu';

interface O_HeaderMobileProps {
  showSearchInput?: boolean;
  actionSlot?: ReactNode;
  hideRightNav?: boolean;
  onSearchChange?: (query: string) => void;
  onSearchSubmit?: (query: string) => void;
}

export default function O_HeaderMobile({
  showSearchInput = true,
  actionSlot,
  onSearchChange,
  onSearchSubmit,
}: O_HeaderMobileProps) {
  const { language } = useLanguage();
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  return (
    <header className={styles.wrapper}>
      <Q_BlurEffect yAxis='top' />
      <div className={styles.top_row}>
        <Link to={PATHS.HOME} className={styles.logo}>
          <A_Logo variant='default' />
        </Link>
        {showSearchInput && (
          <div className={styles.search_wrapper}>
            <A_SearchInput
              placeholder={getTranslation(language, 'header.search')}
              onChange={onSearchChange}
              onSearch={onSearchSubmit}
            />
          </div>
        )}
        <A_CircleButton
          icon={<Q_Icon.BurgerIcon width={24} height={24} fill='none' />}
          variant='transparent'
          onClick={() => setIsMenuOpen(true)}
        />
      </div>
      {actionSlot && <div className={styles.action_slot}>{actionSlot}</div>}
      <O_HeaderBurgerMenu
        isOpen={isMenuOpen}
        onClose={() => setIsMenuOpen(false)}
      />
    </header>
  );
}
